// IDs to filter out of user-facing lists
// The IDs are the same across environments
export const BREED_NOT_PROVIDED_DOG = '594';
export const BREED_NOT_PROVIDED_CAT = '595';
export const COLOR_NOT_PROVIDED_DOG = '355';
export const COLOR_NOT_PROVIDED_CAT = '354';

export const ALL_ACCESS_PRODUCT_ID = '2057';
export const ESSENTIAL_PRODUCT_ID = '2594';
export const ALL_ACCESS_UPGRADE_PRODUCT_ID = '2595';
export const COMPREHENSIVE_EXAM_PRODUCT_ID = '154';
